import React from 'react'

/**
 * Custom `PolarAngleAxis` tick for the MSI radar chart.
 *
 * Row-question labels are full sentences that sit at every angle around the
 * circle, so — unlike the Cartesian `AngledAxisTick` — they can't be uniformly
 * rotated. This truncates the label and exposes the full text via a native SVG
 * `<title>` tooltip on hover. Font sizing comes from the `.matrix-radar-axis-label`
 * CSS class (a class beats the global `text { font-size: 30px }` rule in
 * layout.css; inline `fontSize` is disallowed and would be overridden anyway).
 *
 * Recharts injects `x`, `y`, `textAnchor` and `payload`; pass `fill` from the
 * chart's `graphColor`.
 *
 * @param {object} props
 * @param {number} [props.x] - Tick x-coordinate (injected by Recharts).
 * @param {number} [props.y] - Tick y-coordinate (injected by Recharts).
 * @param {string} [props.textAnchor] - Anchor computed from the tick's angle (injected by Recharts).
 * @param {{ value?: string }} [props.payload] - Tick payload; `value` is the question (injected by Recharts).
 * @param {string} [props.fill] - Text colour; defaults to `currentColor`, dat via
 *   `.matrix-radar-axis-label` op `var(--ink)` uitkomt.
 * @param {number} [props.maxChars] - Truncation length; defaults to 18.
 * @returns {JSX.Element}
 */
const PolarQuestionTick = ({ x, y, textAnchor, payload, fill, maxChars = 18 }) => {
  const full = payload?.value == null ? '' : String(payload.value)
  const truncated = full.length > maxChars ? `${full.slice(0, maxChars - 1)}…` : full

  return (
    <g>
      <title>{full}</title>
      <text
        className="matrix-radar-axis-label"
        x={x}
        y={y}
        textAnchor={textAnchor}
        dominantBaseline="central"
        fill={fill || 'currentColor'}
      >
        {truncated}
      </text>
    </g>
  )
}

export default PolarQuestionTick
